const getImageUrl = (imageValue) => {
    if (Array.isArray(imageValue)) {
        return imageValue.length ? imageValue[0].url : undefined
    }

    return imageValue
}

export default getImageUrl
